import { type Observable } from 'rxjs'

class ObservableManager {
	private observables: Map<string, Observable<any>> = new Map()

	setObservable = <T>(type: string, observable: Observable<T>) => {
		this.observables.set(type, observable)
	}
	getObservable = <T>(type: string): Observable<T> | undefined => {
		return this.observables.get(type)
	}
}

export const observableManager = new ObservableManager()

export const { setObservable, getObservable } = observableManager
